import React, { forwardRef, useEffect, useImperativeHandle, useRef } from "react";

const Turnstile = forwardRef(({ siteKey, onSuccess, options = {} }, ref) => {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);

  useImperativeHandle(ref, () => ({
    reset() {
      if (widgetIdRef.current !== null && window.turnstile) {
        window.turnstile.reset(widgetIdRef.current);
      }
    },
  }));

  useEffect(() => {
    let intervalId;

    const render = () => {
      if (!containerRef.current || widgetIdRef.current !== null) return;
      widgetIdRef.current = window.turnstile.render(containerRef.current, {
        sitekey: siteKey,
        callback: onSuccess,
        theme: options.theme,
        size: options.size,
        appearance: options.appearance,
      });
    };

    if (window.turnstile) {
      render();
    } else {
      intervalId = setInterval(() => {
        if (window.turnstile) {
          clearInterval(intervalId);
          render();
        }
      }, 100);
    }

    return () => {
      clearInterval(intervalId);
      if (widgetIdRef.current !== null && window.turnstile) {
        window.turnstile.remove(widgetIdRef.current);
        widgetIdRef.current = null;
      }
    };
  }, [siteKey]);

  return <div ref={containerRef} />;
});

export { Turnstile };
